import { ActionsColumn, Confirmation } from '@otp/ui';
import { useState } from 'react';
import {
  AssignUserToStoreDocument,
  StoreModel,
  User,
  UsersDocument,
  StoresUserDetailsDocument,
} from 'src/graphql/generated/graphql';
import { UserAdd } from '@otp/icons';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';

type OTPsUnassignedListActionsProps = {
  store: Partial<StoreModel>;
  user: Partial<User>;
};

export const OTPsRestaurantsUnassignedListActions = ({
  store,
  user,
}: OTPsUnassignedListActionsProps) => {
  const [assignMutation] = useMutation(AssignUserToStoreDocument, {
    refetchQueries: [UsersDocument, StoresUserDetailsDocument],
  });
  const { t } = useTranslation(undefined, {
    keyPrefix: 'user-details.modals',
  });
  const [isAssigning, setIsAssigning] = useState(false);

  const onAssign = () => {
    assignMutation({
      variables: {
        userId: user.id,
        storeId: store.id,
      },
    });
    setIsAssigning(false);
  };

  return (
    <>
      <ActionsColumn
        icons={[
          {
            icon: <UserAdd />,
            onClick: () => {
              setIsAssigning(true);
            },
          },
        ]}
      />
      <Confirmation
        open={isAssigning}
        onClose={() => setIsAssigning(false)}
        onConfirm={onAssign}
        message={t('confirm-assign')}
      />
    </>
  );
};
